import AppRouter from './router/routes';
import { ToastContainer } from 'react-toastify';
import React, { useEffect } from 'react';
import 'react-toastify/dist/ReactToastify.css';
import 'bootstrap/dist/css/bootstrap.min.css';
import 'bootstrap-icons/font/bootstrap-icons.css';
import './assets/css/base.css';

function App() {
  useEffect(() => {
    document.title = process.env.REACT_APP_NAME || 'React App';
     // Update existing meta tags
     const metaDescription = document.querySelector('meta[name="description"]');
     if (metaDescription) {
         metaDescription.content = process.env.REACT_APP_META_DESCRIPTION || 'React App Description';
     }

     const metaKeywords = document.querySelector('meta[name="keywords"]');
     if (metaKeywords) {
        metaKeywords.content = process.env.REACT_APP_META_KEYWORDS || 'React App keywords';
     }

     //Disable RIght Click on Website
    // const handleContextMenu = (event) => {
    //   event.preventDefault();
    // };
    // document.addEventListener("contextmenu", handleContextMenu);
    // return () => {
    //   document.removeEventListener("contextmenu", handleContextMenu);
    // };
}, []);

// Disbale Inspect Shortcuts
useEffect(() => {
  const handleKeyDown = (event) => {
    if (
      (event.ctrlKey && event.shiftKey && event.key === "I") || // Ctrl+Shift+I
      (event.ctrlKey && event.key === "U") || // Ctrl+U
      event.key === "F12" // F12
    ) {
      event.preventDefault();
    }
  };
  document.addEventListener("keydown", handleKeyDown);
  return () => {
    document.removeEventListener("keydown", handleKeyDown);
  };
}, []);

  return (
    <div>
      <ToastContainer />
      <AppRouter />
    </div>
  );
}

export default App;
